import React, { createContext, useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({});

  useEffect(() => {
    _setUser();
  }, []);

  const _setUser = async () => {
    const gsccookie = Cookies.get('gsccookie') || null;
    //|| localStorage.getItem('userToken');
   
    if (gsccookie) {
     // console.log("gsccookie found: "+gsccookie)
      try {
        let decoded = { user_uuid: '', email: '',name : '', userType: '', subscriptionFreeUntil: 0, pricing: '' };
        decoded = jwtDecode(gsccookie);
       // console.log("Decoded:", decoded)
        setUser({
         // token: token,
         user_uuid: decoded.user_uuid,
          email: decoded.email,
          name : decoded.name,
          userType: decoded.userType,
          subscriptionFreeUntil: decoded.subscriptionFreeUntil,
          pricing: decoded.pricing,
        });
        //console.log('Payload:', JSON.stringify(decoded));
      } catch (error) {
        console.error('Invalid token:', error);
      }
    } else {
      console.log('Cookie is missing.');
    }
  };

  const _logout = async () => {
    setUser(null);
    // try {
    //   await fetch(`${process.env.REACT_APP_SERVER_URL}/logout`, {
    //     method: 'POST',
    //     credentials: 'include',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   });
    // } catch (error) {
    //   console.error('Logout failed:', error);
    // }
    //Cookies.remove('gsccookie');
    Cookies.remove('gsccookie',{ path: '/', domain: '.goldensparrowcapital.com' });
   window.location.href = '/';
    return 1;
  };

  return (
    <UserContext.Provider
      value={{
        user,
        _setUser,
        _logout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => useContext(UserContext);
